import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-center py-8"
};
const _hoisted_2 = {
  class: "d-flex align-center justify-center fill-height"
};
const _hoisted_3 = {
  key: 4
};
const _hoisted_4 = ["href", "download"];
import { computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { VuePdfEmbed, toPdfSource } from '@/utils/pdfHelpers';
export default {
  __name: 'AttachmentPreview',
  props: {
    fileType: {
      type: String,
      required: true
    },
    previewSource: {
      type: String,
      required: false,
      default: ''
    },
    previewExistingMode: {
      type: Boolean,
      required: false,
      default: false
    },
    showAttachmentPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    hideActionButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    fileName: {
      type: String,
      required: false,
      default: ""
    },
    /** True while the parent is fetching the attachment. */
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    /** Set when the fetch failed; shown in place of the viewer. */
    errorMessage: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['exitPreview', 'addAttachment', 'cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const pdfSource = computed(() => toPdfSource(props.previewSource));
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_img = _resolveComponent("v-img");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        class: "d-flex flex-column min-h-0"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(__props.fileName), 1)]),
        append: _withCtx(() => [_withDirectives(_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        }, 512), [[_vShow, __props.hideActionButtons]])]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, {
          "data-cy": "attachment-preview-viewport",
          class: "d-flex justify-center align-start overflow-y-auto min-h-0"
        }, {
          default: _withCtx(() => [__props.errorMessage ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.errorMessage), 1)) : __props.loading || !__props.previewSource ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 1,
            class: "my-8",
            color: "success",
            indeterminate: ""
          })) : __props.fileType?.indexOf('pdf') > -1 ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
            key: 2,
            width: 600,
            source: pdfSource.value
          }, null, 8, ["source"])) : __props.fileType?.indexOf('image') > -1 && __props.fileType.indexOf('tiff') === -1 ? (_openBlock(), _createBlock(_component_v_img, {
            key: 3,
            class: "mx-auto",
            "aspect-ratio": "1.5",
            "lazy-src": __props.previewSource,
            src: __props.previewSource
          }, {
            placeholder: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_v_progress_circular, {
              color: "success",
              indeterminate: ""
            })])]),
            _: 1
          }, 8, ["lazy-src", "src"])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("a", {
            href: __props.previewSource,
            download: __props.fileName
          }, "Download Attachment", 8, _hoisted_4)]))]),
          _: 1
        }), _withDirectives(_createVNode(_component_v_card_actions, {
          class: "ts"
        }, {
          default: _withCtx(() => [__props.previewExistingMode ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            color: "primary",
            onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('exitPreview'))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Ok", -1)]))]),
            _: 1
          })) : (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 1,
            variant: "outlined",
            onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('addAttachment'))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("Add", -1)]))]),
            _: 1
          })), !__props.previewExistingMode ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 2,
            onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("Cancel", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 512), [[_vShow, !__props.hideActionButtons]])]),
        _: 1
      });
    };
  }
};